import { ENDPOINT_AUTHENTICATION_LOGOUT } from 'api/constants';

export class AuthenticationService {
  static logout = () => {
    window.location.href = ENDPOINT_AUTHENTICATION_LOGOUT;
  };
}
